import {useAuth} from '@common/auth/use-auth';
import {useThemeSelector} from '@common/ui/themes/theme-selector-context';
import {Badge} from '@common/ui/badge/badge';
import {IconButton} from '@common/ui/buttons/icon-button';
import {PersonIcon} from '@common/icons/material/Person';
import {ButtonBase} from '@common/ui/buttons/button-base';
import {ArrowDropDownIcon} from '@common/icons/material/ArrowDropDown';
import {ReactElement} from 'react';
import {ListboxItemProps} from '@common/ui/forms/listbox/item';
import {NavbarAuthMenu} from '@common/ui/navigation/navbar/navbar-auth-menu';
import {useSelectedLocale} from '@common/i18n/selected-locale';
import clsx from 'clsx';
import {useGetProfiles} from '@app/profile/requests/use-get-profiles';

export interface NavbarAuthUserProps {
  onClick?: () => void;
  items?: ReactElement<ListboxItemProps>[];
}
export function NavbarAuthUser({onClick, items = []}: NavbarAuthUserProps) {
  const {user} = useAuth();
  const {selectedTheme} = useThemeSelector();
  if (!selectedTheme || !user) return null;
  const hasUnreadNotif = !!user.unread_notifications_count;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {locale} = useSelectedLocale();
  const getProfiles = useGetProfiles();

  const mobileButton = (
    <IconButton
      onClick={onClick}
      size="md"
      className="!padding-0 !w-fit md:hidden"
      role="presentation"
      aria-label="toggle authentication menu"
      badge={
        hasUnreadNotif ? (
          <Badge>{user.unread_notifications_count}</Badge>
        ) : undefined
      }
    >
      <PersonIcon />
    </IconButton>
  );
  const desktopButton = (
    <ButtonBase className="flex items-center max-md:hidden" role="presentation">
      <img
        className={clsx(
          'h-32 w-32 flex-shrink-0 rounded object-cover',
          locale.language === 'fa' ? 'ml-12' : 'mr-12',
        )}
        src={
          //@ts-expect-error
          getProfiles?.data?.find(ava => ava.id === user?.profiles[0]?.id)
            ?.avatar?.url || user.avatar
        }
        alt=""
      />
      <span
        className={clsx(
          'block max-w-124 overflow-x-hidden overflow-y-hidden overflow-ellipsis text-sm',
          locale.language === 'fa' ? 'ml-2' : 'mr-2',
        )}
      >
        {(user?.profiles && user?.profiles[0]?.name) || user.display_name}
      </span>
      <ArrowDropDownIcon className="block icon-sm" />
    </ButtonBase>
  );

  return (
    <NavbarAuthMenu items={items}>
      <span role="button">
        {mobileButton}
        {desktopButton}
      </span>
    </NavbarAuthMenu>
  );
}
